const Grok02Icon = /*#__PURE__*/ [
  ["path", { d: "M7 9H3L12 22H16L7 9Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6.14913 17.5016L3.00024 22H7.00024L8.13808 20.3745L6.14913 17.5016Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12.9008 13.5706L21.0002 2H17.0002L10.9119 10.6976L12.9008 13.5706Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M18 10.2095V22H21V5.92383L18 10.2095Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export { Grok02Icon as default };
//# sourceMappingURL=Grok02Icon.js.map
